import { render, staticRenderFns } from "./GridPromotedOfferCardMoreInfoV1.vue?vue&type=template&id=2a32e206&scoped=true"
import script from "./GridPromotedOfferCardMoreInfoV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPromotedOfferCardMoreInfoV1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridPromotedOfferCardMoreInfoV1.vue?vue&type=style&index=0&id=2a32e206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32e206",
  null
  
)

export default component.exports